<!-- Responsibility: Implement player profile traits behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<player-profile-traits>
  <section class="pp-section" if={ props.traits && props.traits.length }>
    <h5 class="pp-section-title">TRAITS</h5>
    <div class="pp-grid">
      <trait-card each={ trait in props.traits } trait={ trait }></trait-card>
    </div>
  </section>

  <script>
    import TraitCard from './trait-card.riot'
    export default { components: { TraitCard } }
  </script>

  <style>
    .pp-section { animation: section-in 0.5s ease both; }
    .pp-section-title {
      color: var(--text-dim); font-size: var(--space-sm); letter-spacing: 0.25em; margin: 0 0 1.25rem; border-bottom: 1px solid var(--border); padding-bottom: var(--space-xs);
    }
    .pp-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
      gap: 0.9rem;
    }
    @media (max-width: 40.625rem) { .pp-grid { grid-template-columns: 1fr; } }
  </style>
</player-profile-traits>
